import { InvoicePaymentCollection, PartialInvoicePaymentCollection, submitInvoicePayment } from "@auer-steel/Services/InvoicePaymentService";
import { AuerActions } from "@auer-steel/Store/AuerState";
import updateInvoicePayments from "@auer-steel/Store/Pages/PayInvoice/Handlers/UpdateInvoicePayments";
import { convertToApiParameter, validateSubmission } from "@auer-steel/Utilities/PayInvoiceUtilities";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { DispatchProp } from "react-redux";

export interface PayInvoiceParameter {
    invoicePaymentCollection: InvoicePaymentCollection;
    partialInvoicePaymentCollection: PartialInvoicePaymentCollection[];
    onError?: (message: string) => void;
    onSuccess?: (message: string) => void;
}
type HandlerType = ApiHandler<PayInvoiceParameter, InvoicePaymentCollection, DispatchProp<AuerActions>>;

export const Execute: HandlerType = async props => {
    props.dispatch({ type: "Pages/PayInvoice/BeginSubmit" });
    const collectionWithErrors = await validateSubmission(props.parameter.invoicePaymentCollection);

    if (collectionWithErrors) {
        props.dispatch(updateInvoicePayments(collectionWithErrors));
        props.dispatch({ type: "Pages/PayInvoice/EndSubmit" });
        return false;
    }

    const apiParameter = convertToApiParameter(props.parameter.invoicePaymentCollection, props.parameter.partialInvoicePaymentCollection);

    try {
        const apiResult = await submitInvoicePayment(apiParameter);

        if (!apiResult) {
            if (props.parameter.onError) {
                props.parameter.onError(
                    siteMessage("InvoiceHistory_invoicePaymentFailed").toString());
            }
            
            // Clear invoice redux state so we can ensure UI matches updates made on the server
            props.dispatch({ type: "Data/Invoices/Reset" });
            props.dispatch({ type: "Pages/PayInvoice/EndSubmit" });
            return false;
        }
    }
    catch (e) {
        if (isApiError(e) && e.status === 400) {
            if (props.parameter.onError) {
                props.parameter.onError(
                    siteMessage("InvoiceHistory_invoicePaymentFailed").toString());
            }
        }
    }

    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(
            siteMessage("InvoiceHistory_invoicePaymentSubmitted").toString()
        );
    }

    // Clear invoice redux state so we can ensure UI matches updates made on the server
    props.dispatch({ type: "Data/Invoices/Reset" });
    props.dispatch({ type: "Pages/PayInvoice/EndSubmit" });
    
};

export const chain = [Execute];

const submitInvoicePayments = createHandlerChainRunner(chain, "SubmitInvoicePayments");
export default submitInvoicePayments;
